import React from "react";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export const ImageWithZoom = props => (
	<Zoom>
		<img {...props} alt={props.alt} />
	</Zoom>
);
